import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import adminRoutes from '../../routes/adminRoutes'
import dateUtil from '../../utils/date.util'
import permissionService from '../../services/permission.service'
import siteApi, { SiteUpdateRequest } from '../../apis/site.api'
import permissionApi, { PermissionData } from '../../apis/permission.api'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import Card from '../../components/Card'
import Row from '../../components/Row/Row'
import PageHeading from '../../components/PageHeading'
import InputText from '../../components/InputText'
import DatePicker from '../../components/DatePicker/DatePicker'
import PermissionPicker from '../../components/PermissionPicker'
import CardButton from '../../components/CardButton'

interface SiteEditRouteState {
  id: number
}

interface SiteEditProps extends RouteComponentProps<any, any, SiteEditRouteState> {}

interface SiteEditState {
  name: string
  endAt: string
  address: string
  city: string
  state: string
  zip: string
  permissions: PermissionData[]
  allowedPermissions: PermissionData[]
}

class SiteEdit
  extends Component<SiteEditProps, SiteEditState> {
  constructor (props: SiteEditProps) {
    super(props)
    const date = dateUtil.now()
    this.state = {
      name: '',
      endAt: date,
      address: '',
      city: '',
      state: '',
      zip: '',
      permissions: [],
      allowedPermissions: []
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handlePermissionsChange = this.handlePermissionsChange.bind(this)
    this.handleSaveClick = this.handleSaveClick.bind(this)
  }

  get id () {
    return this.props.location.state.id
  }

  get allowedPermissionNames () {
    const { allowedPermissions } = this.state
    return permissionService.listNames(allowedPermissions)
  }

  get permissionNames () {
    const { permissions } = this.state
    return permissionService.listNames(permissions)
  }

  save () {
    const { name, endAt, address, city, state, zip, permissions } = this.state
    const permissionIds = permissionService.listIds(permissions)
    const payload: SiteUpdateRequest = {}
    if (name) payload.name = name
    if (endAt) payload.endAt = endAt
    if (address) payload.address = address
    if (city) payload.city = city
    if (state) payload.state = state
    if (zip) payload.zip = zip
    if (permissions) payload.permissions = permissionIds
    siteApi.update(this.id, payload, site => {
      if (!site) return
      this.props.history.push(adminRoutes.sites)
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'name') this.setState({ name: value })
    else if (name === 'address') this.setState({ address: value })
    else if (name === 'city') this.setState({ city: value })
    else if (name === 'state') this.setState({ state: value })
    else if (name === 'zip') this.setState({ zip: value })
  }

  handleDateChange (name: string, date: string) {
    if (name === 'endAt') this.setState({ endAt: date })
  }

  handlePermissionsChange (permissionNames: string[]) {
    const { allowedPermissions } = this.state
    const permissions = permissionService.filterByNames(
      allowedPermissions,
      permissionNames
    )
    this.setState({ permissions })
  }

  handleSaveClick () {
    this.save()
  }

  readSite () {
    siteApi.read(this.id, site => {
      if (!site || !site.permissions || !site.address) return
      const { name, endAt, permissions } = site
      const { address, city, state, zip } = site.address
      this.setState({ name, endAt, address, city, state, zip, permissions })
    })
  }

  listAllowedPermissions () {
    permissionApi.list(allowedPermissions => {
      if (!allowedPermissions) return
      this.setState({ allowedPermissions })
    })
  }

  componentDidMount () {
    this.readSite()
    this.listAllowedPermissions()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <Card>
            <PageHeading text={i18n("Edit Site")} />
            <Row column={2}>
              <InputText
                name="name"
                value={this.state.name}
                label={i18n("Name")}
                onChange={this.handleInputChange} />
              <DatePicker
                name="endAt"
                value={this.state.endAt}
                label={i18n("End at")}
                onChange={this.handleDateChange} />
              <InputText
                name="address"
                value={this.state.address}
                label={i18n("Address")}
                onChange={this.handleInputChange} />
              <InputText
                name="city"
                value={this.state.city}
                label={i18n("City")}
                onChange={this.handleInputChange} />
              <InputText
                name="state"
                value={this.state.state}
                label={i18n("State")}
                onChange={this.handleInputChange} />
              <InputText
                name="zip"
                value={this.state.zip}
                label={i18n("Zip")}
                onChange={this.handleInputChange} />
            </Row>
            <PermissionPicker
              allowed={this.allowedPermissionNames}
              permissions={this.permissionNames}
              onChange={this.handlePermissionsChange} />
            <CardButton
              proceedText={i18n("Save")}
              cancelText={i18n("Cancel")}
              onProceedClick={this.handleSaveClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(SiteEdit)
